var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 331,
    viewBox: "0 0 69 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-238.101 328.673C-219.186 305.285 -215.067 301.578 -195.658 286.762C-190.903 283.132 -181.659 277.42 -170.241 271.965C-166.825 270.331 -163.437 268.848 -160.096 267.489C-136.188 257.795 -109.405 256.427 -82.9546 258.679C-15.4655 264.429 45.4465 227.897 63.2038 172.586C80.9895 117.18 51.7294 55.6535 6.06917 25.6316C0.127924 21.7256 -27.9079 4.49558 -58.6676 1.94861C-155.787 -6.11996 -194.595 87.9563 -223.978 231.1C-224.548 233.884 -226.721 247.142 -227.11 249.955L-238.11 328.683L-238.101 328.673Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector14);
export default __webpack_public_path__ + "static/media/vector1-4.b5a82f4a555ee76cd5ba36f1a4d8e394.svg";
export { ForwardRef as ReactComponent };